import CreateForm from "../Templates/Forms/Dynamic-Forms";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Markdown from "react-markdown";
import RingLoader from "react-spinners/RingLoader";
import { useAuthContext } from '../hooks/useAuthContext';
import remarkGfm from 'remark-gfm'
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
// import {BiArrowBack} from "react-icons/bi";
import { AiFillCopy } from "react-icons/ai";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { FaCirclePlay } from "react-icons/fa6";
import { FaLongArrowAltLeft } from "react-icons/fa";
import dayjs from 'dayjs';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useLogout } from "../hooks/useLogout";
function FetchForms() {

    const { user ,dispatch} = useAuthContext()
    const [result, setResult] = useState();
    const params = useParams();
    const[show,setShow] = useState(false);
    const[flashDetails,setFlashDetails] = useState("")
 const [copied] = useState("Copy")
    const{logout} = useLogout()
    const notify = (response) => toast(response);
    
   const navigate = useNavigate()

    //fetch specific flash name and description
    const users = Cookies.get('token')
const getSpecificFlash = async() => {
    const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/flash/specific?slug=${params.flashName}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${users}`
        },
    })
    const json = await response.json()
    setFlashDetails(json)
}
  

    //fetch result from the form in terms of generated content
    const fetchResult = (boolVal,data) => {
        setShow(boolVal)
        setResult(data)
        setShow(boolVal)
    }

    //fetch saved history for respective flash only

    // const getHistory = async () => {
    //     const content = await fetchSpecificHistory(params.flashName)
    //     dispatchcontent({ type: 'FETCH_CONTENTS', payload: content })

    // }

    useEffect(() => {
        const users = Cookies.get('token')
        if(!users ){
         logout()
       }

try{
    const User = jwtDecode(users)
    const checkToken = async() =>{
      const isExpired = dayjs.unix(User.exp).diff(dayjs())< 1;
   
    if(!isExpired){
        getSpecificFlash()
      
    }else{
    
      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/refresh-token`, {
        method: 'GET',
        headers: {'Content-Type':'application/json', 
    }
    })
   
  if(response.status === 200){

     const json = await response.json()

     dispatch({ type: 'LOGIN', payload: json.token })
     navigate("/")
  }else{
 
     logout()
  }
    }
  
  }
    
  
  
  checkToken()
}catch(e){
    if(e.message.includes("Invalid token specified")){
        logout()
        }
}

        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])

 





    if (user) {
        return (
            <div className="min-h-screen lg:w-3/4 md:w-3/4 sm:w-3/4 w-2/3 mt-4 mx-auto">
                           <div className="flex justify-between ">
                   
                           <Link to="/"><FaLongArrowAltLeft className="text-gray-600 hover:text-black dark:text-white hover:cursor-pointer mb-2"  size={25}/></Link>


    <Link className="flex font-Rajdhani  text-gray-600 no-underline hover:text-black dark:text-white " to="/product-updates">
  <p className="text-md pr-1 ">How to use flashes?</p>
  <FaCirclePlay  className="text-gray-600 dark:text-white" size={20}/>
  </Link>
    


</div>
                <div className="rounded p-4 shadow-xl border-1">
               
                <div class="d-flex position-relative align-items-center ">
              <div class="position-absolute  opacity-10 top-0 right-0 bottom-0 left-0 "></div>
          
            <div
       
                dangerouslySetInnerHTML={{ __html: flashDetails.icon }}
                className="bg-red-400 overflow-hidden  rounded-full"
            // Set width and height to 100% to fill the parent div
            />
        </div>
                  <h1 className="text-3xl mt-3 font-Rajdhani font-medium">{flashDetails.title}</h1>
                  <p className="text-xl font-Rajdhani font-medium dark:text-gray-300">{flashDetails.description}</p>
           

                <CreateForm onSubmit={fetchResult} />
                </div>
                <div className="mt-10">
                    <Tabs
                        defaultActiveKey="results"
                        id="fill-tab-example"
                        className="mb-3 font-normal"
                        nav-justified
                        nav-fill
                    >
                        <Tab eventKey="results" title="Results">

{result ? (
Array.isArray(result) ? (
result.map((result, index) => (
<div key={index} className="results font-normal border-1 p-4 shadow-sm rounded my-5 heading-sm">
<p>
<Markdown remarkPlugins={[remarkGfm]}>
{result}
</Markdown>
</p>
<CopyToClipboard text={result} onCopy={() => notify("Copied!")}>
<span className="flex dark:hover:text-slate-300">
<AiFillCopy size={20} className="cursor-pointer dark:hover:text-slate-300" />
<p className="cursor-pointer px-1 dark:hover:text-slate-300">{copied}</p>
</span>
</CopyToClipboard>
</div>
))
) : (
// Display the error message if result is not an array
<div className="error-message">
<p>{result}</p>
</div>
)
) : (
<div>
{/* <BeatLoader visible={show} color="#dd412b" /> */}
{show === true ? null : <p className="font-Rajdhani text-xl">Generate content now! Visit history to view/edit previously generated content</p>}
<RingLoader
loading={show}
height="80"
width="80"
ariaLabel="vortex-loading"
wrapperClass="vortex-wrapper"
color="#dd412b"
/>
</div>
)}


<ToastContainer
position="top-right"
autoClose={2000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"
/>


</Tab>

                  
                    </Tabs>
                </div>
            </div>
        )
    }else{
        return navigate("/")
    }
}
export default FetchForms;